module.exports = __webpack_public_path__ + "img/1582321913.0af9b45a.jpg";